import { observer } from 'mobx-react-lite';
import { lazy } from 'react';
import Background from './background';
import { freeBetStore } from '../../store/freeBetStore';
import './freebet-popup.scss';
import { FREE_BET_STATUS, FREE_BET_WIN_TYPES } from '../../core/constants/freeBet';

const FreeBetContent = lazy(() => import('./content/index'));

const FreeBetWrapper = observer(() => {
  const { isShowFreeBetPopup, currentFreeBet } = freeBetStore;

  if (!currentFreeBet || !isShowFreeBetPopup) return null;
  return (
    <Background
      isWinWithBet={currentFreeBet.winType === FREE_BET_WIN_TYPES.BetPlusWin}
      isAwardPopup={currentFreeBet.status === FREE_BET_STATUS.pending}
    >
      <FreeBetContent />
    </Background>
  );
});

export default FreeBetWrapper;
